export type ColorPalette = {
  primary: string
  primaryHover: string
  primaryLight: string
  highlight: string
  textColor: string
  lightGrey: string
  mediumGrey: string
  darkGrey: string
  error: string
  surface: string
  white: string
}

export type Color = keyof ColorPalette

export type Theme = {
  typography: any // TODO: implement
  colors: {
    light: ColorPalette
  }
}

const THEME: Theme = ((scale = 1) => {
  const fontFamily = "system-ui !important"
  const rootFontSize = 16 * scale
  const fontWeightLight = 300
  const fontWeightRegular = 400
  const fontWeightMedium = 700
  const fontWeightBold = 900
  return {
    typography: {
      rootFontSize,
      fontFamily,
      fontWeightLight,
      fontWeightRegular,
      fontWeightMedium,
      fontWeightBold,
      button: {
        fontFamily: fontFamily,
        fontWeight: fontWeightBold,
        letterSpacing: "0px",
        fontSize: `${rootFontSize * 0.9}px`,
      },
      inputMessage: {
        fontFamily: fontFamily,
        fontSize: `${rootFontSize * 0.8}px`,
      },
      hyperlink: {
        fontFamily: fontFamily,
        fontSize: `${rootFontSize * 0.9}px`,
        lineHeight: `${rootFontSize * 0.9 * 1.5}px`,
        fontWeight: fontWeightRegular,
        textDecoration: "underline",
      },
      subtitle: {
        fontFamily: fontFamily,
        fontSize: `${rootFontSize * 0.9}px`,
        lineHeight: `${rootFontSize * 0.9 * 1.5}px`,
        fontWeight: fontWeightRegular,
      },
      text: {
        fontFamily: fontFamily,
        fontSize: `${rootFontSize * 0.9}px`,
        lineHeight: `${rootFontSize * 1.5}px`,
      },
    },
    colors: {
      light: {
        primary: "#307EF7",
        primaryHover: "#518EFC",
        primaryLight: "#B9D0FF",
        highlight: "#22D563",
        textColor: "#424242",
        lightGrey: "#f5f5f5",
        mediumGrey: "#e5e5e5",
        darkGrey: "#939393",
        error: "#B00020",
        surface: "#F8F8F8",
        white: "#FFFFFF",
      },
    },
  }
})()
export default THEME

// TODO: Check if these colors can be added to the theme palette without breaking the Vuetify Theme
export const errorBackgroundTint = "#F5E9EB"
export const successBackgroundTint = "#E9F5ED"
export const successColor = "#3EB068"
